import React from 'react';
import {withTranslation} from "react-i18next";
import TranslatedTextComponent from "./TranslatedTextComponent";

let AuthErrorComponent = ({onRetryClicked, message, stack, t}) => {
    return <div>


            <h1 className="text-center">{t('authentication.error')}</h1>


                <div id="accordion">
                    <div className="card">
                        <div className="card-header" id="errorHeading">
                            <h5 className="mb-0">
                                <button className="btn btn-link" data-toggle="collapse" data-target="#collapseError"
                                        aria-expanded="true" aria-controls="collapseError">
                                    <TranslatedTextComponent textKey="authentication.show_error"/>
                                </button>
                            </h5>
                        </div>

                        <div id="collapseError" className="collapse" aria-labelledby="errorHeading"
                             data-parent="#accordion">
                            <div className="card-body">
                                <div>
                                    {message}
                                </div>
                                <pre>
                                    {stack}
                                </pre>
                            </div>
                        </div>
                    </div>
                </div>


            <button id="loginBtn" onClick={() => onRetryClicked()}> {t('authentication.retry')} </button>
        </div>;
}

export default withTranslation() (AuthErrorComponent)